import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-order_pop_icon_error",
  "use": "icon-order_pop_icon_error-usage",
  "viewBox": "0 0 11 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 11\" id=\"icon-order_pop_icon_error\"><path d=\"M5.485 0a5.485 5.485 0 1 1 0 10.97 5.485 5.485 0 0 1 0-10.97Zm1.96 3.525a.346.346 0 0 0-.49 0L5.484 4.998 4.03 3.545a.343.343 0 1 0-.484.485l1.452 1.453-1.462 1.462a.345.345 0 1 0 .488.489L5.486 5.97 6.94 7.424a.343.343 0 1 0 .485-.485L5.97 5.486l1.473-1.473a.346.346 0 0 0 0-.488Z\" fill=\"#F5181B\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol